<!--<template>
  <div id="app">
      <header>
        <Navbar/>
      </header>
  </div>
</template>

<script>
import Navbar from './components/Navbar';

export default {
  name: 'App',
  components: {
    Navbar,
  }
}
</script>-->

<template>
  <div id="app">
      <Carousel_rooms :slides="slides"></Carousel_rooms>
  </div>
</template>

<script>
import Carousel_rooms from './components/Carousel_rooms';

export default {
  name: 'AppS',
   data: () => ({
    /*slides: [
      "/wp-content/uploads/2023/11/j2-1.webp",
      "/wp-content/uploads/2023/11/domatio2.webp",
      "/wp-content/uploads/2023/11/domatio3-scaled-1.webp",
      "/wp-content/uploads/2023/11/domatio4.webp",
      "/wp-content/uploads/2023/11/dom5.webp",
      "/wp-content/uploads/2023/11/domatio6.webp"
    ]*/
 
    slides: [
      "/wp-content/uploads/2024/10/AROANIOS-PHOTO_13-scaled-1.webp",
      "/wp-content/uploads/2024/10/AROANIOS-PHOTO_10-scaled-1.webp",
      "/wp-content/uploads/2024/10/AROANIOS-PHOTO_11-scaled-1.webp",
    ]
  }),
  components: {
    Carousel_rooms,
  }
}
</script>

